import { get, isEqual } from 'lodash';

import type { HotelIngredient } from '@apps/main/modules/recipe/ingredients';

import { AccommodationType } from '@libs/trip-planner-interfaces';

import {
  DEFAULT_ACTIVITY_SELECTION_FILTERS,
  ALL_ACTIVITY_SELECTION_FILTERS,
  ACTIVITY_SELECTION_FILTER_PILLS_CONFIG,
} from '../../models';
import type {
  ActivitySelectionFilter,
  ActivitySelectionFilterPillData,
  ActivitySelectionFiltersForm,
} from '../../models';

export function getActivitySelectionFilterFromIngredient(
  hotelIngredient: HotelIngredient
): ActivitySelectionFiltersForm {
  return {
    activityName: hotelIngredient.filters.activitiesFilterText,
    types: {
      tickets: hotelIngredient.filters.selectedActivityTypes.includes(
        AccommodationType.Ticket
      ),
      golf: hotelIngredient.filters.selectedActivityTypes.includes(
        AccommodationType.Golf
      ),
    },
  };
}

export function getActiveFilters(
  form: ActivitySelectionFiltersForm
): ActivitySelectionFilterPillData[] {
  return ALL_ACTIVITY_SELECTION_FILTERS.filter(
    (filter: ActivitySelectionFilter) => {
      const currentValue = get(form, filter);
      const defaultValue = get(DEFAULT_ACTIVITY_SELECTION_FILTERS, filter);
      return !isEqual(currentValue, defaultValue);
    }
  ).map((filter: ActivitySelectionFilter) => {
    const config = ACTIVITY_SELECTION_FILTER_PILLS_CONFIG[filter];
    return { type: config.type, text: config.textFactory(form) };
  });
}
